"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineMaster = exports.BoxMaster = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var input_1 = require("./input");
var translate_1 = require("remota-common/util/translate");
var fat_1 = require("remota-common/util/fat");
var BoxMaster = function (props) {
    var value = props.value, onSearch = props.onSearch, onChange = props.onChange, onFocus = props.onFocus, _a = props.masters, masters = _a === void 0 ? [] : _a, _b = props.selectHeadOnExit, selectHeadOnExit = _b === void 0 ? false : _b, _c = props.isLoading, isLoading = _c === void 0 ? false : _c, inputRef = props.inputRef;
    var queryValue = value ? (typeof value === "string" ? value : value.displayValue) : "";
    var _d = __read(react_1.default.useState({
        propsValue: value,
        query: queryValue,
        isOpen: false,
    }), 2), state = _d[0], setState = _d[1];
    var isSelected = react_1.default.useRef(false);
    var isQuitted = react_1.default.useRef(false);
    var search = react_1.default.useMemo(function () {
        return (0, debounce_1.default)(function (query) {
            onSearch && onSearch(query);
        }, 300);
    }, [onSearch]);
    var handleExit = react_1.default.useCallback(function () {
        setTimeout(function () {
            if (!isSelected.current) {
                if (onChange) {
                    if (masters[0] && selectHeadOnExit) {
                        onChange(masters[0]);
                        if (!isQuitted.current) {
                            setState({ query: masters[0].displayValue, isOpen: false });
                        }
                    }
                    else {
                        onChange(null);
                        if (!isQuitted.current) {
                            setState({ query: "", isOpen: false });
                        }
                    }
                }
            }
        }, 200);
    }, [onChange, masters, selectHeadOnExit, setState, isSelected, isQuitted]);
    var handleFocus = react_1.default.useCallback(function () {
        onFocus && onFocus();
        setState(function (state) { return (__assign(__assign({}, state), { isOpen: true })); });
        isSelected.current = false;
    }, [onFocus, setState, isSelected]);
    var handleChange = react_1.default.useCallback(function (e) {
        var query = e.target.value;
        setState(function (state) { return (__assign(__assign({}, state), { query: query })); });
        search(query);
    }, [setState, search]);
    react_1.default.useEffect(function () {
        if (!(0, isEqual_1.default)(state.propsValue, value)) {
            setState(__assign(__assign({}, state), { propsValue: value, query: queryValue }));
        }
    }, [queryValue, state, value]);
    react_1.default.useEffect(function () { return function () {
        isQuitted.current = true;
    }; }, []);
    return (react_1.default.createElement(RootArea, null,
        react_1.default.createElement(MasterBoxInput, { isOpen: state.isOpen, value: state.query, onFocus: handleFocus, onBlur: handleExit, onChange: handleChange, ref: inputRef }),
        !state.isOpen ? null : (react_1.default.createElement(Results, { type: "box", onChange: onChange, masters: masters, isLoading: isLoading, setState: setState, isSelected: isSelected }))));
};
exports.BoxMaster = BoxMaster;
var MasterBoxInput = (0, styled_components_1.default)(input_1.BoxInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 32px;\n  border-radius: ", ";\n"], ["\n  height: 32px;\n  border-radius: ", ";\n"])), function (props) { return (props.isOpen ? props.theme.borderRadius.above : undefined); });
var LineMaster = function (props) {
    var value = props.value, onSearch = props.onSearch, onChange = props.onChange, _a = props.masters, masters = _a === void 0 ? [] : _a, _b = props.selectHeadOnExit, selectHeadOnExit = _b === void 0 ? false : _b, _c = props.isLoading, isLoading = _c === void 0 ? false : _c, inputRef = props.inputRef;
    var queryValue = value ? (typeof value === "string" ? value : value.displayValue) : "";
    var _d = __read(react_1.default.useState({
        propsValue: value,
        query: queryValue,
        isOpen: false,
    }), 2), state = _d[0], setState = _d[1];
    var isSelected = react_1.default.useRef(false);
    var isQuitted = react_1.default.useRef(false);
    var search = react_1.default.useMemo(function () {
        return (0, debounce_1.default)(function (query) {
            onSearch && onSearch(query);
        }, 300);
    }, [onSearch]);
    var handleExit = react_1.default.useCallback(function () {
        setTimeout(function () {
            if (!isSelected.current) {
                if (onChange) {
                    if (masters[0] && selectHeadOnExit) {
                        onChange(masters[0]);
                        if (!isQuitted.current) {
                            setState({ query: masters[0].displayValue, isOpen: false });
                        }
                    }
                    else {
                        onChange(null);
                        if (!isQuitted.current) {
                            setState({ query: "", isOpen: false });
                        }
                    }
                }
            }
        }, 500);
    }, [onChange, masters, selectHeadOnExit, setState]);
    var handleFocus = react_1.default.useCallback(function () {
        setState(function (state) { return (__assign(__assign({}, state), { isOpen: true })); });
        isSelected.current = false;
    }, [setState, isSelected]);
    var handleChange = react_1.default.useCallback(function (e) {
        var query = e.target.value;
        setState(function (state) { return (__assign(__assign({}, state), { query: query })); });
        search(query);
    }, [setState, search]);
    react_1.default.useEffect(function () {
        if (!(0, isEqual_1.default)(state.propsValue, value)) {
            setState(__assign(__assign({}, state), { propsValue: value, query: queryValue }));
        }
    }, [queryValue, state, value]);
    react_1.default.useEffect(function () { return function () {
        isQuitted.current = true;
    }; }, []);
    return (react_1.default.createElement(RootArea, null,
        react_1.default.createElement(input_1.LineInput, { value: state.query, onFocus: handleFocus, onBlur: handleExit, onChange: handleChange, ref: inputRef }),
        !state.isOpen ? null : (react_1.default.createElement(Results, { type: "line", onChange: onChange, masters: masters, isLoading: isLoading, setState: setState, isSelected: isSelected }))));
};
exports.LineMaster = LineMaster;
var Results = react_1.default.memo(function (props) {
    var type = props.type, onChange = props.onChange, masters = props.masters, isLoading = props.isLoading, setState = props.setState, isSelected = props.isSelected;
    var handleClick = react_1.default.useCallback(function (e) {
        var index = e.currentTarget.dataset.index;
        if (onChange && index && masters[Number(index)]) {
            onChange(masters[Number(index)]);
            setState({ query: masters[Number(index)].displayValue, isOpen: false });
            isSelected.current = true;
        }
    }, [onChange, masters, setState, isSelected]);
    if (!isLoading && masters.length === 0) {
        return (react_1.default.createElement(ResultArea, { type: type, maxCount: 9.5 },
            react_1.default.createElement(ResultItem, { notSelectable: true },
                react_1.default.createElement(fat_1.Fat, { id: (0, translate_1.fat)("結果が見つかりませんでした") }))));
    }
    return (react_1.default.createElement(ResultArea, { type: type, maxCount: 9.5 },
        isLoading ? (react_1.default.createElement(ResultItem, { notSelectable: true },
            react_1.default.createElement(fat_1.Fat, { id: (0, translate_1.fat)("Loading") }))) : null,
        masters.map(function (master, i) { return (react_1.default.createElement(ResultItem, { key: master.id, "data-index": i, onClick: handleClick }, master.displayValue)); })));
});
var RootArea = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ResultArea = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 2px);\n  max-height: ", "px;\n  overflow: scroll;\n\n  box-sizing: content-box;\n  top: ", ";\n  left: 0px;\n\n  background-color: ", ";\n  border-radius: ", ";\n  border: 1px ", " solid;\n  border-top: none;\n"], ["\n  position: absolute;\n\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 2px);\n  max-height: ", "px;\n  overflow: scroll;\n\n  box-sizing: content-box;\n  top: ", ";\n  left: 0px;\n\n  background-color: ", ";\n  border-radius: ", ";\n  border: 1px ", " solid;\n  border-top: none;\n"])), function (props) { return props.maxCount * 24; }, function (props) {
    switch (props.type) {
        case "box":
            return "32px";
        case "line":
            return "24px";
    }
}, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.borderRadius.beneath; }, function (props) { return props.theme.colors.tableGray1; });
var ResultItem = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 0 0 24px;\n  font-size: 12px;\n  line-height: 12px;\n  padding: 6px 12px;\n  box-sizing: border-box;\n  background-color: ", ";\n  &:hover {\n    cursor: ", ";\n    background: ", ";\n  }\n"], ["\n  flex: 0 0 24px;\n  font-size: 12px;\n  line-height: 12px;\n  padding: 6px 12px;\n  box-sizing: border-box;\n  background-color: ", ";\n  &:hover {\n    cursor: ", ";\n    background: ", ";\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return (props.notSelectable ? undefined : "pointer"); }, function (props) { return (props.notSelectable ? undefined : props.theme.colors.gray2Transparent); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
